// eslint-disable-next-line no-restricted-imports
import { Empty as AntEmpty, EmptyProps } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export type EmptyComponentProps = Omit<EmptyProps, 'description'> & {
    description?: React.ReactNode;
};

export const Empty = ({ description, ...props }: EmptyComponentProps) => {
    const { t } = useTranslation();

    return (
        <StyledEmpty
            description={description || t('Empty.Description')}
            image={null}
            {...props}
        />
    );
};

const StyledEmpty = styled(AntEmpty)`
    .ant-empty-image {
        display: none;
    }
`;
